import * as Sentry from '@sentry/browser';

const fn = globals.config.debug ? null : Sentry.addBreadcrumb;
const SENTRY_LEVEL_MAPPING = Object.freeze({ debug: 'debug', info: 'info', warn: 'warning', error: 'error' });

// NOTE: Use plugin presets
const consolePresets = {};

// NOTE: `vue-log` config for Sentry
const sentryPresets = {
    logger: Sentry,
    proxy: false,
    levels: [
        { name: 'debug', fn },
        { name: 'info', fn },
        { name: 'warn', fn },
        { name: 'error', fn },
    ],
    middlewares: [
        (result, { level, config, statements }) => {
            result.push({
                message: statements.toString ? statements.toString() : '',
                category: 'vue-log',
                level: SENTRY_LEVEL_MAPPING[level.name],
                data: JSON.parse(JSON.stringify(config.context)),
            });

            return result;
        },
    ],
};

export default (globals.config.debug ? consolePresets : sentryPresets);
